import { Component, OnInit, AfterViewInit,
   Output, EventEmitter, Input, HostListener, ElementRef, forwardRef } from '@angular/core';
import { RegAutocompleteModel } from 'src/app/core/models/properties.model';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true
    }
  ]
})
export class AutocompleteComponent implements OnInit, ControlValueAccessor {

  constructor(
    private eRef: ElementRef
  ) { }

  form: FormGroup;
  @Input() isMkt = false;
  @Input() defaultValue = '';
  @Input() internalValue = '';
  @Input() height = '44px';
  @Input() width: string = '';
  @Output() ElementSelected = new EventEmitter<string | { value: string, index: number, result: any }>();
  @Input() emitIndex = false;
  @Output() autocompleteSearch = new EventEmitter<string>();
  @Output() toggleClearButton = new EventEmitter<boolean>();
  @Input() autoSearchResults: RegAutocompleteModel[] = [];
  @Input() placeholder = '';
  @Input() value = '';
  @Input() maxLength = null;
  @Input() showSearch = true;
  @Input() enhanveOnHover = false;
  @Input() inputId = '';
  @Input() onlyDescription = false;
  @Input() loading: boolean = false;  
  autocomp = false;
  autocompIdx = -1;
  defaultPos;
  timer;
  defaultWidth = "306px";

  onChange: any = () => { /*Empty*/ };
  onTouched: any = () => { /*Empty*/ };

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.autocomp && this.autoSearchResults.length) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.autoSearchResults = [];
        this.autocomp = false;
      }
    }
  }

  ngOnInit(): void {
    document.documentElement.style.setProperty('--height', `${this.height}`);    
    this.form = new FormGroup({
      searchInput: new FormControl('')
    });
    
  }

  ngAfterViewInit(): void {
    this.setWidthToMainDiv();
  }

  get searchInput() {
    return this.internalValue;
  }

  set searchInput(val: any) {
    if (val === undefined || val === null || val === '') {
      this.internalValue = '';
      this.onChange(undefined);
      return;
    }
    this.internalValue = val;
    this.form.controls.searchInput.setValue(val);
    this.onChange(val);
  }

  setWidthToMainDiv(): void {
    if (this.width) {
      document.getElementById(`div-${this.inputId}`).setAttribute("style",`width:${this.width}`);
    } else {
      document.getElementById(`div-${this.inputId}`).setAttribute("style",`width:${this.defaultWidth}`);
    }
  }

  writeValue(val: any): void {
    this.defaultValue = val;
    this.onChange(val);
    this.internalValue = val;
    this.form.controls.searchInput.setValue(val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  downList(event): void {
    if (this.autocomp === false) {
      return;
    }
    if ((event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 27)) {
      switch (event.keyCode) {
        case 40:
          if (this.autocompIdx < this.autoSearchResults.length - 1) {
            this.autocompIdx += 1;
          }
          break;
        case 38:
          if (this.autocompIdx > 0) {
            this.autocompIdx -= 1;
          }
          break;
        case 27:
          this.autocomp = false;
          this.autocompIdx = -1;
          return;
      }
      this.updateSearchInput();
    }
  }

  setFilter() {
    this.searchProduct();
  }

  selectAutocomplete() {
    this.searchProduct(this.autocompIdx);
    this.autocomp = false;
    this.autocompIdx = -1;
  }

  pointerSelection(idx: number): void {
    this.autocompIdx = idx;
  }

  patchInputValue(index?: number): void {
    this.autocomp = false;
    this.updateSearchInput();
    this.searchProduct(index);
    this.form.controls.searchInput.setValue('');
    this.autocompIdx = -1;
  }

  updateSearchInput(): void {
    let description;
    if (this.autoSearchResults[this.autocompIdx][this.value]) {
      description = this.autoSearchResults[this.autocompIdx][this.value];
    } else {
      description = this.autoSearchResults[this.autocompIdx]['name'];
    }
    const plainText = description
        .replace(/<strong>/g, '')
        .replace(/<\/strong>/g, '');
    this.form.controls.searchInput.setValue(plainText);
    this.writeValue(this.form.value.searchInput);
  }

  searchProduct(index?: number) {
    if (this.form.value.searchInput.length >= 3) {
      this.autocomp = false;
      if (!this.emitIndex) {
        this.ElementSelected.emit(this.form.value.searchInput);
      }
      if (this.emitIndex && (index || index === 0)) {
        this.ElementSelected.emit({ value: this.form.value.searchInput, index, result: this.autoSearchResults[index] });
      }
    }
  }

  searchAutocomplete(event: string | number): void {
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      const searchTxt = String(event);
      if (searchTxt.trim().length > 2) {
        this.autocompleteSearch.emit(searchTxt);
        this.autocomp = true;
      } else {
        this.autocomp = false;
        this.autocompIdx = -1;
      }
      if (searchTxt.trim().length > 0) {
        this.toggleClearButton.emit(true);
      }else{
        this.toggleClearButton.emit(false);
      }
    }, 800)
  }

  resetValue() {
    this.form = new FormGroup({
      searchInput: new FormControl('')
    });
  }

  closeDropdown() {
    this.autocomp = false;
  }
}
